define('model/arrayMerge',[], function () {
    "use strict";

    function defaultComparator(first, second) {
        return first === second;
    }

    return function (firstArray, secondArray, comparator) {
        if (!comparator) {
            comparator = defaultComparator;
        }

        var result = firstArray.concat(secondArray);
        for (var i = 0; i < firstArray.length; i += 1) {
            for (var j = firstArray.length; j < result.length; j += 1) {
                if (comparator(result[i], result[j])) {
                    result.splice(j, 1);
                    j -= 1;
                }
            }
        }
        return result;
    };
});
